import { concat } from '@/helpers/string';

import type { MissionPeriod } from '@/types/mission';

export const getHours = (period: number = 15) => {
	const hours = [];
	for (let i = 0; i < 24; i++) {
		for (let j = 0; j < 60; j += period) {
			const minutes = String(j).padStart(2, '0');
			hours.push({
				label: concat([String(i), minutes], ':'),
				value: String(i) + minutes,
			});
		}
	}
	return hours;
};

export const getHourLabelFromValue = (hourValue: string | null) =>
	getHours().find((hour) => hour.value === hourValue)?.label;
export const getHourIndexFromValue = (hourValue: string | null) =>
	getHours().findIndex((hour) => hour.value === hourValue);

export const convertPeriodsToDateRanges = (periods: MissionPeriod[]) => {
	const safePeriods = periods.filter(
		(period: MissionPeriod) => period.slots.all?.length > 0
	);
	if (safePeriods.length === 0) return [];
	return safePeriods.map((period: MissionPeriod) => ({
		startDate: period.start,
		endDate: period.end,
		startTime: period.slots.all[0].from.toString(),
		endTime: period.slots.all[0].to.toString(),
		weekendIncluded: period.weekendIncluded ?? false,
	}));
};
